module.exports = __webpack_public_path__ + "static/media/yellow-stamp-wave.35901c18.png";